import React from 'react'
import { useState } from 'react';
import { Box, Button, IconButton, InputBase } from '@mui/material';
import Styles from "../../../Styles/DashBoard.module.css"
import TopBar from "../../../Components/LayoutWapper/Global/TopBar";
import Sidebar from "../../../Components/LayoutWapper/Global/SideBar";
import Data1 from "../../../Components/Myjobs/Data1";
import Data2 from "../../../Components/Myjobs/Data2";
import Data3 from "../../../Components/Myjobs/Data3";
import SearchIcon from '@mui/icons-material/Search';
import Widget from  "../../../Assets/Widget.png";
import Fire from "../../../Assets/fire.png"
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';








function Index() {

  const [activeTab, setActiveTab] = useState("tab1");
  const [input , setInput ] = useState("")
  const fetchData =(value) => {
    fetch("../")

  }

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  function toggleSidebar() {
    setIsSidebarOpen(!isSidebarOpen);
  }
  const handleChange = (value) => {
    setInput(value)
    fetchData(value)
  }

  // handle tab switching
  const handleTab1 = () => {
    setActiveTab("tab1");
  };

  const handleTab2 = () => {
    setActiveTab("tab2");
  };
  const handleTab3 = () => {
    setActiveTab("tab3");
  };

  return  (
      <div className={Styles.container}>
      <TopBar toggleSidebar={toggleSidebar}/>
      <div className={Styles.main} >
       <div className={Styles.context} >
       <div className={Styles.nav}>
       {isSidebarOpen && <Sidebar />}
       </div>
       <div className={Styles.center}>
        <div className={Styles.info}>
        <div className={Styles.Header}>
         <h1>Welcome Babatunde Samuel</h1> 
        </div>
          <div className={Styles.jobcontainer} >
            <div className={Styles.col1} >
              <div className={Styles.card}>
                <div className={Styles.search}>
                <Box
                display="flex" 
                width="310px" 
                border="0.5px solid #999999" 
                borderRadius="5px"
                height="40px"
                
                >
                <IconButton  type='button' sx={{p : 1 }}  disableRipple>
                <SearchIcon sx={{ width:"14.25px", height:"14.25px" , color:"rgba(153, 153, 153, 1)" }}/>
                 <InputBase sx={{ ml: 1, flex: 1, fontSize:"12px" , }} placeholder="Job Title, Company" 
                 value={input} onChange={(e) => handleChange(e.target.value)} />
                 </IconButton>
                 </Box> 
                 <Box
                   display="flex" 
                   width="310px" 
                   border="0.5px solid #999999" 
                   borderRadius="5px"
                   height="40px"
                 >
                  <IconButton type='button' sx={{p : 1}} disableRipple>
                  <SearchIcon sx={{ width:"14.25px", height:"14.25px"  ,color:"rgba(153, 153, 153, 1)"  }} />
                 <InputBase sx={{ ml: 1, flex: 1 ,fontSize:"12px" }} placeholder="City, State"/>
                 </IconButton>
                 </Box>
                 
                 <Button sx={{ width:"113px" , height:"43px" ,fontSize:"12px", background: "rgba(243, 114, 63, 1)",color:"#fff",
                 "&:hover": { backgroundColor:"rgba(243, 114, 63, 1)"}
                
                }}>Find Jobs</Button>       
                </div>
             <div className={Styles.selectjob}>
              <h2>Jobs based on your profile</h2>
              <div className={Styles.jobsection}>
                <div className={Styles.section1}>
                 <div className={Styles.subsection}>
                  <div  className={activeTab === "tab1" ? Styles.active : ""}
                   onClick={handleTab1}   
                  id={Styles.jobscards}  >
                    <div className={Styles.carddetails}>
                     <ul>
                      <li className={Styles.head} >UI/UX Designer</li>
                      <li>Cdlp Hub Ltd</li>
                      <li>Ibadan</li>
                      <li>On-site</li>
                      <li className={Styles.tail}>Posted 2 days ago</li>
                     </ul>
                     <div className={Styles.infolist} id={Styles.infolist}>
                       <BusinessCenterOutlinedIcon sx={{ width:"16.67px", height:"15.83px" , color:"rgba(243, 114, 63, 1)"}}/>
                        <p>Fulltime</p>
                     </div>
                    </div>
                  </div>
                  <div  className={activeTab === "tab2" ? Styles.active : ""}
                   onClick={handleTab2}   
                  id={Styles.jobscards}  >
                   <div className={Styles.carddetails}>
                   <ul>
                      <li className={Styles.head}>Front-end Developer</li>
                      <li>Cdlp Hub Ltd</li>
                      <li>Ibadan</li>
                      <li>On-site</li>
                      <li className={Styles.tail}  >Posted 2 days ago</li>
                     </ul> 
                     <div className={Styles.infolist}>
                       <BusinessCenterOutlinedIcon sx={{ width:"16.67px", height:"15.83px" , color:"rgba(243, 114, 63, 1)"}}/>
                        <p>contract</p>
                     </div>
                  </div>
                  </div>
                  <div className={activeTab === "tab3" ? Styles.active : ""}
                   onClick={handleTab3}   
                  id={Styles.jobscards}   >
                  <div className={Styles.carddetails} >
                  <ul>
                      <li className={Styles.head} >Front-end Developer</li>
                      <li>Cdlp Hub Ltd</li>
                      <li>On-site</li>
                      <li>Cdlp Hub Ltd</li>
                      <li className={Styles.tail}  >Posted 2 days ago</li>
                     </ul>
                     <div className={Styles.infolist}>
                       <BusinessCenterOutlinedIcon sx={{ width:"16.67px", height:"15.83px" , color:"rgba(243, 114, 63, 1)"}}/>
                        <p>contract</p>
                     </div>
                  </div>
                 </div>
                 </div>
                </div>
                <div className={Styles.section2}> 
                {activeTab === "tab1" ? <Data1/> : activeTab === "tab2" ? <Data2/> : <Data3/>}
                </div>
              </div>
             </div>
              </div>
            </div>
            <div className={Styles.col2}>
            <div className={Styles.card}>
             <div className={Styles.content}>
             <div className={Styles.header} >
             <h3>Hottest jobs right now</h3>
             <img  src={Fire} width={20}  height={20} alt="/"/>
             </div>
             <div className={Styles.Suggestions2}>
                <div className={Styles.One}>
                 <img  src={Widget} alt="" width="35px" height="10px" /> 
                 <div className={Styles.text}>
                 <h3>Front-end Developer</h3>
                 <p>Cdlp Hub. Fulltime</p>
                </div>
                </div>
                <div className={Styles.One}>
                <img  src={Widget} alt="" width="35px" height="10px"  /> 
                <div className={Styles.text}>
                 <h3>Back-end Developer</h3>
                 <p>Cdlp Hub. Fulltime</p>
                </div>
               </div>
               <div className={Styles.One}>
                <img  src={Widget} alt="" width="35px" height="10px"  /> 
                <div className={Styles.text}>
                 <h3>Back-end Developer</h3>
                 <p>Cdlp Hub. Fulltime</p>
                </div>
               </div>
               <div className={Styles.One}>
                <img  src={Widget} alt="" width="35px" height="10px"  /> 
                <div className={Styles.text}>
                 <h3>Back-end Developer</h3>
                 <p>Cdlp Hub. Fulltime</p>
                </div>
               </div>
               <div className={Styles.One}>
                <img  src={Widget} alt="" width="35px" height="10px"  /> 
                <div className={Styles.text}>
                 <h3>Back-end Developer</h3>
                 <p>Cdlp Hub. Fulltime</p>
                </div>
               </div>
              </div>
             </div>
            </div>
            </div>
          </div>
          </div>
          </div>
         </div>
       </div> 
       </div>
      
  )
}

export default Index;